module.exports = __webpack_public_path__ + "img/benefits-fitness.4cb21bb2.jpg";